/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { getCollectionTemplate } from "../../get-collection-template";
import { getDefaultStoriesCount } from "../../../utils";
import isEmpty from "lodash/isEmpty";
import "./issue-landing-page.m.css";
import { MagazineEditions } from "@quintype/arrow";

export const getCollectionStories = (currentEditionCollection = {}, config = {}, layout = "", storiesStartIndex) => {
  const storiesCount = parseInt(config.initialLoadCount) || getDefaultStoriesCount(layout);
  const storiesEndIndex = storiesStartIndex + storiesCount;
  const collectionItems = currentEditionCollection.items.slice(storiesStartIndex, storiesEndIndex);
  storiesStartIndex = storiesStartIndex + storiesCount;
  return {
    ...currentEditionCollection,
    items: collectionItems,
    currentOffset: storiesStartIndex
  };
};

export const MagazineCollection = props => {
  const { layout, ...restProps } = props;
  const updatedConfig = () => {
    switch (layout) {
      case "ArrowThreeColSevenStory":
        return { config: { ...restProps.metadata, showButton: false, navigate: false } };
      case "ArrowFourColGrid":
        return {
          config: { initialLoadCount: 8, ...restProps.metadata, footerButton: "SubsequentLoadCount", navigate: false }
        };
      default:
        return { config: { ...restProps.metadata } };
    }
  };

  const Component = getCollectionTemplate(layout);
  return React.createElement(Component, {
    ...restProps,
    metadata: updatedConfig()
  });
};
MagazineCollection.propTypes = {
  layout: PropTypes.string
};

export const IssueLandingPage = ({ data = {}, config = {} }) => {
  const { rows: magazineRows = [], pageSetting = {} } = get(
    config,
    ["pagebuilder-config", "magazine", "issue-landing"],
    {}
  );
  if (!magazineRows.length) return <div styleName="info-message">Magazine configuration is missing.</div>;

  const currentEdition = get(data, ["currentEdition", "collection"]);
  if (!currentEdition) return <div styleName="info-message">No editions found.</div>;

  const {
    topStoriesCollection,
    allStoriesCollection,
    magazineSlug = "",
    otherEditions = [],
    magazineTitle = ""
  } = data;

  let storiesStartIndex = 0;

  return (
    <>
      {magazineRows.map(row => {
        const { name, layout, config } = row;
        switch (name) {
          case "headerEdition":
            config.customUrlPath = `/subscription?group=${magazineSlug}`;
            const metadata = {
              ...config,
              magazineTitle,
              magazinePageUrl: `/magazine/${magazineSlug}`
            };
            return <MagazineCollection key={name} collection={currentEdition} layout={layout} metadata={metadata} />;
          case "otherEditions":
            if (otherEditions.length) {
              return (
                <div styleName="editions-wrapper">
                  <MagazineEditions
                    key={name}
                    collection={otherEditions}
                    config={{
                      ...{ theme: pageSetting.bgColor },
                      ...config,
                      magazineSlug,
                      isArchivePage: true
                    }}
                    showLoadmore={config.showButton}
                  />
                </div>
              );
            }
            break;
          case "topStories":
          case "allStories":
            let collection = {};
            const rowCollection = name === "topStories" ? topStoriesCollection : allStoriesCollection;
            if (!isEmpty(rowCollection.collection)) {
              collection = rowCollection.collection;
            } else {
              collection = getCollectionStories(currentEdition, config, layout, storiesStartIndex);
              storiesStartIndex = collection.currentOffset;
            }
            return <MagazineCollection key={name} collection={collection} layout={layout} metadata={config} />;
        }
      })}
    </>
  );
};

IssueLandingPage.propTypes = {
  data: PropTypes.shape({
    currentEdition: PropTypes.shape({
      collection: PropTypes.object
    }),
    otherEditions: PropTypes.array
  }),
  config: PropTypes.shape({
    "pagebuilder-config": PropTypes.shape({
      magazine: PropTypes.shape({
        rows: PropTypes.array,
        pageSetting: PropTypes.object
      })
    })
  })
};
